export function getDownloadEverything(state) {
    return state.LauncherShouldDownloadEverything
}

export function getRunClientsWithLogging(state) {
    return state.LauncherRunClientsWithLogging
}

export function getRunClientsWithDx9(state) {
    return state.LauncherRunClientsWithDx9
}

export function getShouldMinimizeToTray(state) {
    return state.LauncherShouldMinimizeToTray
}

export function getLanguage(state) {
    return state.LauncherLanguage
}

export function getTestServers(state) {
    return state.LauncherTestServers
}

export function getLauncherType(state) {
    return state.LauncherType
}

export function getBackendSettings(state) {
    return {
        LauncherEnableHardwareRendering: state.LauncherEnableHardwareRendering,
        LauncherEnableHighDpiScaling: state.LauncherEnableHighDpiScaling,
        LauncherIgnoreCertErrors: state.LauncherIgnoreCertErrors,
        LauncherLanguage: state.LauncherLanguage === 'en' ? '' : state.LauncherLanguage,
        LauncherRunClientsWithDx9: state.LauncherRunClientsWithDx9,
        LauncherRunClientsWithLogging: state.LauncherRunClientsWithLogging,
        LauncherShouldDownloadEverything: state.LauncherShouldDownloadEverything,
        LauncherShouldMinimizeToTray: state.LauncherShouldMinimizeToTray,
        LauncherTestServers: [...state.LauncherTestServers],
        LauncherType: state.LauncherType,
        LauncherUseProxy: state.LauncherUseProxy,
        ResManThreadCount: state.ResManThreadCount,
    }
}



// WEBPACK FOOTER //
// ./src/features/Settings/data/backend/selectors.js